import {
  medigiLanding,
  medshortsLanding,
  outsourcingLanding,
} from 'src/app/shared/models/landing';
import { defaultSupplierConfig } from 'src/environments/hydra/configs';
import { hydraSupplierConfigMap } from 'src/environments/hydra/config.map';

const _domain = 'ipsen-demo.medigi.com';

const supplierConfig =
  window.location.host in hydraSupplierConfigMap
    ? hydraSupplierConfigMap[window.location.host]
    : (_domain in hydraSupplierConfigMap
      ? hydraSupplierConfigMap[_domain]
      : defaultSupplierConfig);

const baseURL = 'https://ipsen-demo-api.medigi.com';

export const environment = {
  production: false,
  env_name: 'demo',
  domain: _domain,
  url: 'https://ipsen-demo.medigi.com',
  api_url_v1: baseURL,
  api_url_v2: baseURL,
  singleton_service_url: 'https://default-demo-api.medigi.com',
  medshorts_url: 'https://staging.medshorts.com',
  flower_url: 'http://localhost:8081/misc/flower/dashboard',
  health_url: 'http://localhost:8081/misc/health',
  auth_url: `${baseURL}/auth`,
  auth_url_login: `${baseURL}/auth/login`,
  proxy_url: 'http://localhost:8081/misc/proxy',
  express222Form: 'asdf',
  gatag: undefined,
  clientDomains: {
    outsourcingDomian: 'ipsen-demo-503b.medigi.com',
    medigiDomain: 'ipsen-demo.medigi.com',
    medshortsDomain: 'ipsen-demo-medshorts.medigi.com',
    cgtDomain: '',
  },
  availableThemes: {
    'ipsen-demo.medigi.com': medigiLanding,
    'ipsen-demo-medshorts.medigi.com': medshortsLanding,
    'ipsen-demo-503b.medigi.com': outsourcingLanding,
  },
  catalogType: {
    'ipsen-demo.medigi.com': 'medigi',
    'ipsen-demo-medshorts.medigi.com': 'medshorts',
    'ipsen-demo-503b.medigi.com': '503b',
  },
  hydraEnabled: true,
  customLogoutURL: undefined,
  auth0: {
    clientId: 'n20sGi7hlL8qprFCaAOwnOHnJ6lN7kzT',
    domain: 'hydralower.us.auth0.com',
    apiIdentifier: 'https://hydralower.us.auth0.com/api/v2/',
    appMetadata: 'http://hydralower.com/api/app_metadata',
    userMetadata: 'http://hydralower.com/api/user_metadata',
    supplierHostMap: {},
  },
  sentry: {
    dsn: undefined,
  },
  legisym_url: 'https://demo.dev.express222.com/prompt.php',
  supplierConfig: supplierConfig,
};
